export const EMOJI_MARKER_LABEL = "Emoji Note Marker";
